import React from 'react';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../utils';

const DropdownOption = ({
  isCurrent, handleSelect, label, value,
}: DropdownOptionProps) => (
  <div
    aria-selected={isCurrent}
    className={getClassNames(null, 'c-expandable__dropdown-option', {
      'c-expandable__dropdown-option--current': isCurrent,
    })}
    onClick={() => handleSelect(value)}
    onKeyDown={() => handleSelect(value)}
    role="option"
    tabIndex={0}
  >
    {label}
  </div>
);

const dropdownOptionPropTypes = {
  isCurrent: PropTypes.bool.isRequired,
  handleSelect: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

DropdownOption.propTypes = dropdownOptionPropTypes;

type DropdownOptionProps = PropTypes.InferProps<typeof dropdownOptionPropTypes>;

export default DropdownOption;
